import 'es6-promise/auto'
import Vue from 'vue'
import Axios from 'axios'
import VueFileAgent from 'vue-file-agent';
import swal from 'sweetalert';
import 'vue2-datepicker/index.css';
import 'vue-file-agent/dist/vue-file-agent.css';
import mobile from 'is-mobile';
import {debounce} from "lodash";


Vue.use(VueFileAgent);

import TotalSearchMykeyword from "./components/common/total_search_mykeyword";

new Vue({
  el: '#h',
  data: function () {
    return {
      title: '',
      navbarMenu: false,
      v1: false,
      v2: false,
      v3: false,
      v4: false,
      v5: false,
      v6: false,
      v7: false,
      detailProfile: null,
      detail: null,
      // 인기검색어
      popwordList: [],
      // 내가 찾은 검색어
      mywordList: [],
      // 자동 완성
      autowordList: [],
      // 연관 검색어
      recommendList: [],
    }
  },
  watch: {
    title(n) {
      this.onChangeTitle(n)
    }
  },
  created: function () {

  },
  mounted: function () {
    // pageLoad(this);
    this.fnOnLoadInit();
    this.fnGetProfile();

  },
  methods: {
    navbarBurger: function () {
      this.navbarMenu = true

    },
    /*
    navbarburgerback.addEventListener('click', () => {
        navbarMenu.classList.remove('active');
        navbarOverlay.classList.remove('active');
    });
    */
    navbarOverlay: function () {
      this.navbarMenu = false
    },
    fnOnLoadInit: function () {
      this.loadPopwordList().then() // 인기검색어 로딩
      this.myKeywordLoad(); // 최근 검색어 로딩

    },
    getSearch: function () {
      if(this.title == '') {
        swal("검색어를 입력해주세요").then(function() {
          document.querySelector('#search1').focus();
        });
      }
      else {
        TotalSearchMykeyword.addMyKeyword(this.title, 10) // 내가 찾은 검색어 추가

        // if (this.isMobile) { // TODO CHECK :: 통합검색 모바일 대기중이므로 기존 화면 사용
        // location.href = "/customer/expinfo/share/search?title=" + this.title; // 기존 통합검색
        // } else if (location.pathname.indexOf('/customer/expinfo/share/search_exp') > -1) {
        //   location.href = "/customer/expinfo/share/search_exp?title=" + this.title; // 검색엔진 통합검색 페이징
        // } else {
        location.href = "/customer/expinfo/share/search2?title=" + encodeURI(this.title); // 검색엔진 통합검색
      }


      // }
    },
    fnGetProfile: function () {
      let vm = this;
      let param = {};
      // /api/profile/upload
      Axios.all([
        Axios.post("/api/admin/user/detail/profile", param)
      ]).then(Axios.spread((data1) => {
        // output of req.
        vm.detail = data1.data.detailUser;

        vm.detailProfile = (data1.data.detailUser == null || data1.data.detailUser.filenewname == null) ? "" : "/img/" + data1.data.detailUser.filenewname.substring(0, 8) + "/" + data1.data.detailUser.filenewname;

      }));
    }
    ,
    doSearch: function (word) {
      this.title = word
      this.getSearch()
    },
    /** 검색영역 데이터 로딩 */
    loadSearchLayerData: async function () {
      this.loadPopwordList().then() // 인기검색어 로딩
      this.myKeywordLoad(); // 최근 검색어 로딩
    },
    /* 인기검색어 로딩 */
    loadPopwordList: async function () {
      // 조회범위 : D 일 W 주 M 월
      const ret = await Axios.get("/search/popword.do", {params: {range: 'M'}})
      // console.log("popwordList = ", ret.data?.Data?.Query) // content : "검색광고" count : 1 id : 2 updown : "U"
      this.popwordList = ret.data?.Data?.Query ?? []
    },
    /*최근 검색어 로딩*/
    myKeywordLoad: function () {
      this.mywordList = TotalSearchMykeyword.getMyKeywordAll()
    },
    /*최근 검색어 하나 삭제*/
    myKeywordDel: function (word) {
      TotalSearchMykeyword.removeMyKeyword(word)
      this.myKeywordLoad();
    },
    /*최근 검색어 전체 삭제*/
    myKeywordRemoveAll: function () {
      TotalSearchMykeyword.removeAllMyKeyword()
      this.myKeywordLoad();
    },

    goToLogin: function (url, serviceName) {
      swal({
        text: serviceName + "는 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
        closeOnClickOutside: false,
        buttons: {
          confirm: {
            text: "확인",
            value: true,
            visible: true
          },
          cancel: {
            text: "취소",
            value: false,
            visible: true
          }
        }
      }).then(result => {
        if (result) {
          location.href = "/youthnavi/signup/login?returnURI=" + url;
        }
      });
    },
    /* 자동완성 */
    onChangeTitle: debounce(async function (n) {
      // console.log("***" + n)
      // http://localhost:8080/search/ark.do?query=캠프
      // console.log("쿼리 = " + n)
      const ret = await Axios.get("/search/arkSimple.do", {params: {query: n}})
      // console.log(ret)
      this.autowordList = ret.data?.list ?? []
      console.log("this.autowordList = ", this.autowordList)
      // "hkeyword": "<font style='font-size:13px'><font style='color:#CC6633'>1</font>2월</font>",
      // "keyword": "12월",
      // "count": 30,
      // "type": 1,
      // "linkname": "",
      // "linkurl": ""
    }, 300)
  }
});
